import React from 'react';
import { Box } from '@mui/material';
import MessageBase from './MessageBase';
import FormattedText from '../FormattedText';

const TextMessage = ({ text, sender, timestamp, status }) => {
    // Calcula si necesitamos ajustar el padding basado en la longitud del texto
    const textLength = text.length;
    const needsExtraPadding = textLength > 3;
    
    return (
        <MessageBase sender={sender} timestamp={timestamp} status={status}>
            <Box sx={{ 
                paddingBottom: needsExtraPadding ? '15px' : '5px' 
            }}>
                <FormattedText text={text} />
            </Box>
        </MessageBase>
    );
};

export default TextMessage;